<template>
  <div class="workbench-card">
    <div class="card-content">
      <div class="card-icon">
        <slot name="icon"></slot>
      </div>
      
      <div class="card-info">
        <div class="title-row">
          <h3 class="card-title">{{ title }}</h3>
          
          <div class="card-actions">
            <slot v-if="$slots.actions" name="actions"></slot>
            <template v-else>
              <!-- Original:
              <ActionButton
                v-if="showPreview"
                text="Preview"
                default-color="#374957"
                hover-text-color="#1E4670"
                pressed-text-color="#1E4670"
                hover-bg-color="rgba(30, 70, 112, 0.08)"
                pressed-bg-color="rgba(30, 70, 112, 0.12)"
                @click="$emit('preview')"
              >
                <template #prefix>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M9 4.875C11.8425 4.875 14.3775 6.4725 15.615 9C14.3775 11.5275 11.8425 13.125 9 13.125C6.1575 13.125 3.6225 11.5275 2.385 9C3.6225 6.4725 6.1575 4.875 9 4.875ZM9 3.375C5.25 3.375 2.0475 5.7075 0.75 9C2.0475 12.2925 5.25 14.625 9 14.625C12.75 14.625 15.9525 12.2925 17.25 9C15.9525 5.7075 12.75 3.375 9 3.375ZM9 7.125C10.035 7.125 10.875 7.965 10.875 9C10.875 10.035 10.035 10.875 9 10.875C7.965 10.875 7.125 10.035 7.125 9C7.125 7.965 7.965 7.125 9 7.125ZM9 5.625C7.14 5.625 5.625 7.14 5.625 9C5.625 10.86 7.14 12.375 9 12.375C10.86 12.375 12.375 10.86 12.375 9C12.375 7.14 10.86 5.625 9 5.625Z" fill="currentColor"/>
                  </svg>
                </template>
              </ActionButton>
              -->
              <FoldableButton
                v-if="showPreview"
                text="Preview"
                built_in_theme="default"
                @click="$emit('preview')"
              >
                <template #prefix>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M9 4.875C11.8425 4.875 14.3775 6.4725 15.615 9C14.3775 11.5275 11.8425 13.125 9 13.125C6.1575 13.125 3.6225 11.5275 2.385 9C3.6225 6.4725 6.1575 4.875 9 4.875ZM9 3.375C5.25 3.375 2.0475 5.7075 0.75 9C2.0475 12.2925 5.25 14.625 9 14.625C12.75 14.625 15.9525 12.2925 17.25 9C15.9525 5.7075 12.75 3.375 9 3.375ZM9 7.125C10.035 7.125 10.875 7.965 10.875 9C10.875 10.035 10.035 10.875 9 10.875C7.965 10.875 7.125 10.035 7.125 9C7.125 7.965 7.965 7.125 9 7.125ZM9 5.625C7.14 5.625 5.625 7.14 5.625 9C5.625 10.86 7.14 12.375 9 12.375C10.86 12.375 12.375 10.86 12.375 9C12.375 7.14 10.86 5.625 9 5.625Z" fill="currentColor"/>
                  </svg>
                </template>
              </FoldableButton>

              <!-- Original:
              <ActionButton
                v-if="showEdit"
                text="Edit"
                default-color="#374957"
                hover-text-color="#1E4670"
                pressed-text-color="#1E4670"
                hover-bg-color="rgba(30, 70, 112, 0.08)"
                pressed-bg-color="rgba(30, 70, 112, 0.12)"
                @click="$emit('edit')"
              >
                <template #prefix>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8969 3.16575C19.0892 3.45687 19.0571 3.85248 18.8008 4.10876L9.60845 13.3011C9.51422 13.3954 9.39659 13.4628 9.26766 13.4965L5.43923 14.4965C5.31437 14.5291 5.18566 14.5284 5.06473 14.4976C4.93616 14.4649 4.81639 14.3982 4.71937 14.3011C4.5311 14.1129 4.45676 13.8389 4.52405 13.5813L5.52405 9.75284C5.55351 9.64003 5.60881 9.52861 5.68529 9.44121L14.9117 0.21967C14.9925 0.138906 15.0898 0.0784602 15.1957 0.0416313C15.2742 0.0143243 15.3574 0 15.4421 0C15.641 0 15.8318 0.0790175 15.9724 0.21967L18.8008 3.0481C18.8374 3.08471 18.8695 3.12416 18.8969 3.16575ZM17.2098 3.57843L15.4421 1.81066L6.92391 10.3288L6.29893 12.7216L8.69169 12.0966L17.2098 3.57843Z" fill="currentColor"/>
                    <path d="M17.0834 14.9103C17.3568 12.5727 17.4438 10.2188 17.3444 7.87079C17.3397 7.75837 17.3819 7.64898 17.4615 7.56942L18.4448 6.58609C18.5657 6.46519 18.7723 6.54194 18.7836 6.71254C18.9685 9.50219 18.8984 12.3045 18.5733 15.0846C18.3367 17.1071 16.7124 18.6921 14.7003 18.917C11.2338 19.3044 7.65042 19.3044 4.18385 18.917C2.17179 18.6921 0.547457 17.1071 0.310903 15.0846C-0.103634 11.5403 -0.103635 7.95973 0.310903 4.41543C0.547456 2.3929 2.17179 0.807889 4.18385 0.583012C6.8136 0.289099 9.51054 0.218149 12.1727 0.370161C12.3443 0.379958 12.4225 0.587575 12.301 0.709093L11.3084 1.70165C11.2298 1.78034 11.1218 1.82261 11.0106 1.81885C8.78419 1.74376 6.54263 1.82872 4.35046 2.07373C3.02035 2.22239 1.95486 3.272 1.80075 4.58968C1.39975 8.01821 1.39975 11.4818 1.80075 14.9103C1.95486 16.228 3.02035 17.2776 4.35046 17.4263C7.70631 17.8013 11.1779 17.8013 14.5337 17.4263C15.8638 17.2776 16.9293 16.228 17.0834 14.9103Z" fill="currentColor"/>
                  </svg>
                </template>
              </ActionButton>
              -->
              <FoldableButton
                v-if="showEdit"
                text="Edit"
                built_in_theme="default"
                @click="$emit('edit')"
              >
                <template #prefix>
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M18.8969 3.16575C19.0892 3.45687 19.0571 3.85248 18.8008 4.10876L9.60845 13.3011C9.51422 13.3954 9.39659 13.4628 9.26766 13.4965L5.43923 14.4965C5.31437 14.5291 5.18566 14.5284 5.06473 14.4976C4.93616 14.4649 4.81639 14.3982 4.71937 14.3011C4.5311 14.1129 4.45676 13.8389 4.52405 13.5813L5.52405 9.75284C5.55351 9.64003 5.60881 9.52861 5.68529 9.44121L14.9117 0.21967C14.9925 0.138906 15.0898 0.0784602 15.1957 0.0416313C15.2742 0.0143243 15.3574 0 15.4421 0C15.641 0 15.8318 0.0790175 15.9724 0.21967L18.8008 3.0481C18.8374 3.08471 18.8695 3.12416 18.8969 3.16575ZM17.2098 3.57843L15.4421 1.81066L6.92391 10.3288L6.29893 12.7216L8.69169 12.0966L17.2098 3.57843Z" fill="currentColor"/>
                    <path d="M17.0834 14.9103C17.3568 12.5727 17.4438 10.2188 17.3444 7.87079C17.3397 7.75837 17.3819 7.64898 17.4615 7.56942L18.4448 6.58609C18.5657 6.46519 18.7723 6.54194 18.7836 6.71254C18.9685 9.50219 18.8984 12.3045 18.5733 15.0846C18.3367 17.1071 16.7124 18.6921 14.7003 18.917C11.2338 19.3044 7.65042 19.3044 4.18385 18.917C2.17179 18.6921 0.547457 17.1071 0.310903 15.0846C-0.103634 11.5403 -0.103635 7.95973 0.310903 4.41543C0.547456 2.3929 2.17179 0.807889 4.18385 0.583012C6.8136 0.289099 9.51054 0.218149 12.1727 0.370161C12.3443 0.379958 12.4225 0.587575 12.301 0.709093L11.3084 1.70165C11.2298 1.78034 11.1218 1.82261 11.0106 1.81885C8.78419 1.74376 6.54263 1.82872 4.35046 2.07373C3.02035 2.22239 1.95486 3.272 1.80075 4.58968C1.39975 8.01821 1.39975 11.4818 1.80075 14.9103C1.95486 16.228 3.02035 17.2776 4.35046 17.4263C7.70631 17.8013 11.1779 17.8013 14.5337 17.4263C15.8638 17.2776 16.9293 16.228 17.0834 14.9103Z" fill="currentColor"/>
                  </svg>
                </template>
              </FoldableButton>

              <!-- Original:
              <ActionButton
                v-if="showArchive"
                text="Archive"
                default-color="#D10000"
                hover-text-color="#F63B3B"
                pressed-text-color="#A60B0B"
                hover-bg-color="rgba(209, 0, 0, 0.08)"
                pressed-bg-color="rgba(209, 0, 0, 0.12)"
                @click="$emit('archive')"
              >
                <template #prefix>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0V1H16V3H15V16C15 17.1 14.1 18 13 18H3C1.9 18 1 17.1 1 16V3H0V1H5V0H11ZM3 16H13V3H3V16ZM5 5H7V14H5V5ZM11 5H9V14H11V5Z" fill="currentColor"/>
                  </svg>
                </template>
              </ActionButton>
              -->
              <FoldableButton
                v-if="showArchive"
                text="Archive"
                built_in_theme="red"
                @click="$emit('archive')"
              >
                <template #prefix>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11 0V1H16V3H15V16C15 17.1 14.1 18 13 18H3C1.9 18 1 17.1 1 16V3H0V1H5V0H11ZM3 16H13V3H3V16ZM5 5H7V14H5V5ZM11 5H9V14H11V5Z" fill="currentColor"/>
                  </svg>
                </template>
              </FoldableButton>
            </template>
          </div>
        </div>
        
        <p v-if="description" class="card-description">{{ description }}</p>
      </div>
    </div>
    
    <div v-if="notes" class="card-footer">
      <p class="card-notes">{{ notes }}</p>
    </div>
  </div>
</template>

<script>
// import ActionButton from './ActionButton.vue';

export default {
  name: 'WorkbenchCard',
  components: {
    // ActionButton, // replaced by globally registered FoldableButton
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ''
    },
    notes: {
      type: String,
      default: ''
    },
    showPreview: {
      type: Boolean,
      default: true
    },
    showEdit: {
      type: Boolean,
      default: true
    },
    showArchive: {
      type: Boolean,
      default: true
    }
  },
  emits: ['preview', 'edit', 'archive']
};
</script>

<style scoped>
.workbench-card {
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  border-radius: 10px;
  padding: 24px;
  width: 100%;
  transition: all 0.5s ease;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-sizing: border-box;
}

.workbench-card:hover {
  background: #F9FBFD;
  border-color: #004879;
}

.card-content {
  display: flex;
  gap: 12px;
}

.card-icon {
  flex-shrink: 0;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  background: #E4F3F5;
  border-radius: 8px;
  color: #004879;
  box-sizing: border-box;
  transition: all 0.5s ease;
}

.workbench-card:hover .card-icon {
  background: #004879;
  color: #FFFFFF;
}

.card-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.title-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  min-height: 28px;
}

.card-title {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #374957;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex: 1;
  min-width: 0;
}

.card-description {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #333;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
  align-items: flex-start;
}

.card-footer {
  padding-left: 68px;
}

.card-notes {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #999;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
